import { makeObservable, observable, computed, action } from 'mobx';

import { erpApiurl } from '../stores/APIEndpoints';

const PENDING = 'pending';
const DONE = 'done';
const ERROR = 'error';

const EMPTY_MESSAGE = { status: "", help: "" };
const ERROR_MESSAGE = { status: "error", help: "Unable to fetch the ReferrerDetails. The Service is unavailable. Please try after sometime." };

export default class TrendAnalysisStore {

    state = PENDING;
    message = EMPTY_MESSAGE;

    referrerData = [];

    startDate = '';
    endDate = '';
    interval = '';

    selectedReferrer = "No Referrer Selected";
    selectedRefId = '';
    selectedRefChart = undefined;


    isClicked = false;

    selectedRefTransactions = [];

    diffChange = 0;
    dateBill = [];

    chartData = [
        ['Date', 'BillAmount'],
        [1, 300],
        [2, 530],
        [3, 250],
        [4, 750],
        [5, 300],
        [6, 650],
        [7, 432],
        [8, 372],
        [9, 392],
        [10, 502],
    ]
    TrendOptions = {
        title: 'Number of Tests Suggested ',
        hAxis: { title: 'Date' },
        vAxis: { title: 'BillAmount'},
    }

    constructor(props) {
        this.apiProxy = props.apiProxy;
        this.collectionType = props.collectionType;

        makeObservable(this, {
            state: observable,
            message: observable,
            
            referrerData: observable,

            startDate: observable,
            endDate: observable,
            interval: observable,
            
            selectedReferrer: observable,
            selectedRefId: observable,
            isClicked: observable,

            selectedRefTransactions: observable,

            diffChange: observable,
            dateBill: observable,

            isLoading: computed,
            isError: computed,
            isDone: computed,

            updateReferrerId: action,
            publishLabChart: action,

            fetchTransactions: action,
            updateShowTransactions: action,
            clearShowTransactions: action,
        });
    }


    get isLoading() {
        return this.state === PENDING;
    }

    get isError() {
        return this.state === ERROR;
    }

    get isDone() {
        return this.state === DONE;
    }

    clearShowTransactions = () => {
        this.selectedRefTransactions = [];
        this.isClicked = false;
    }

    clearSelectedReferrer = () => {
        this.selectedRefChart = undefined;
        this.isClicked = false;
        this.selectedRefTransactions = [];
    }

    updateReferrerId = (id, name) => {
        console.log(id);
        this.selectedRefId = id; 
        this.selectedReferrer = name;
    }

    updateShowTransactions = () => {
        this.isClicked = true;
        this.fetchTransactions();
    }

    updateSelectedDate = (dates) => {
        this.startDate = dates[0];
        this.endDate = dates[1];
    }

    updateSelectedInterval = (value) => {
        this.interval = value;
    }

    publishLabChart = () => {

    }
   
    /**
     * Send the request to the endpoint using the FetchAPI
     * 
     */
    fetchSummary = async () => {

        const url = `${erpApiurl}api/Carbon/GetIcSummary?collectionType=daily`;
        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        try {
            const response = await this.apiProxy.getAsync(url);
            const data = await response.json();

            if (data.Message) {
                this.message = ERROR_MESSAGE;
                this.state = DONE;
                return;
            }

            this.referrerData = data;
            this.state = DONE;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE
            console.log(e);
        }
    }

    fetchTransactions = async () => {

        const url = `${erpApiurl}api/Carbon/GetIcDoctorSummary?ReferrerId=${this.selectedRefId}&collectionType=daily`; // collectiontype should be dynamic//

        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        try {
            const response = await this.apiProxy.getAsync(url);
            const data = await response.json();

            if (data.Message) {
                this.message = ERROR_MESSAGE;
                this.state = DONE;
                return;
            }
            console.log(data);
            this.selectedRefTransactions = data;
            this.state = DONE;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE;
        }
    }

    calculateDiffLast = (chartData, interval) => {
        var firstTotal = 0;
        if(interval == "5d") {
            for(let i=0; i<5; i++) {
                firstTotal = firstTotal + chartData[i][1];
            }
        var lastTotal =0;
            for(let i=chartData.length; i>chartData.length-5; i--) {
                lastTotal = lastTotal + chartData[i][1];
            }
        }
        var diff = lastTotal - firstTotal;
        var changeInDiff = (diff/firstTotal) * 100;
        this.diffChange = changeInDiff;

    }
}
